import axios from 'axios';
import Button from 'components/Button/Button';
import CheckBox from 'components/CheckBox/CheckBox';
import Input from 'components/Input/Input';
import TextArea from 'components/TextArea/TextArea';
import React, { useState } from 'react';
import './ShareYourKnowlegeForm.module.scss';

// Import components

export default function ShareYourKnowlegeForm() {
  const [name, setName] = useState('');
  const [work, setWork] = useState('');
  const [email, setEmail] = useState('');
  const [shareCheckbox, setShareCheckbox] = useState(false);
  const [careGiverCheckbox, setCareGiverCheckbox] = useState(false);
  const [contactCheckbox, setContactCheckbox] = useState(false);
  const [textArea, setTextArea] = useState('');

  const sendForm = () => {
    axios
      .post('/api/share', {
        name,
        work,
        email,
        shareCheckbox,
        careGiverCheckbox,
        contactCheckbox,
        textArea,
      })
      .then(() => {
        alert('Uw bericht is verstuurd!');
      })
      .catch((e) => {
        console.error(e);
        alert('Er ging iets mis, probeer opnieuw');
      });
  };

  return (
    <div styleName="ShareYourKnowledgeForm">
      <div styleName="rule">
        <p>Hallo, mijn naam is</p>
        <div styleName="input-wrapper">
          <Input
            variant="underline"
            name="name"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </div>
        <p>En ik ben werkzaam als</p>
        <div styleName="input-wrapper">
          <Input
            variant="underline"
            name="work"
            onChange={(e) => setWork(e.target.value)}
            value={work}
          />
        </div>
        .
      </div>
      <div styleName="rule" onClick={() => setShareCheckbox(!shareCheckbox)}>
        <div styleName="checkbox">
          <CheckBox checked={shareCheckbox} />
          <p>
            Ik deel graag mijn ervaring en kennis om een bijdrage te leveren aan
            #YouToo? zodat anderen hiervan kunnen leren.
          </p>
        </div>
      </div>
      <div
        styleName="rule"
        onClick={() => setCareGiverCheckbox(!careGiverCheckbox)}
      >
        <div styleName="checkbox">
          <CheckBox checked={careGiverCheckbox} />
          <p>
            Ik heb als hulpverlener een vraag hoe ik beter om kan gaan met een
            slachtoffer van seksueel geweld.
          </p>
        </div>
      </div>
      <div
        styleName="rule"
        onClick={() => setContactCheckbox(!contactCheckbox)}
      >
        <div styleName="checkbox">
          <CheckBox checked={contactCheckbox} />
          <p>Ik wil graag in contact komen de makers van #YouToo?.</p>
        </div>
      </div>
      <div styleName="rule">
        <p>Ik ben te bereiken met het volgende e-mailadres</p>
        <div styleName="input-wrapper">
          <Input
            variant="underline"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </div>
        .
      </div>
      <div styleName="text-area">
        <p>Hierbij mijn verhaal:</p>
        <TextArea
          value={textArea}
          onChange={(e) => setTextArea(e.target.value)}
        />
      </div>
      <div styleName="button">
        <Button onClick={sendForm}>Versturen</Button>
      </div>
    </div>
  );
}
